import AceEditor from "react-ace";
import "ace-builds/src-min-noconflict/ext-language_tools";
import "ace-builds/src-min-noconflict/mode-javascript";
import "ace-builds/src-min-noconflict/theme-dracula";

const AceEditorField = ({ value, label, handleChange, name }) => {
  return (
    <>
      <label className="text-sm font-medium text-gray-50 block">{label}</label>
      <div className="border border-gray-700 rounded-lg">
        <AceEditor
          mode="javascript"
          theme="dracula"
          name={name}
          className="ace-editor bg-gray-900 rounded-lg text-sm"
          height="330px"
          width="full"
          defaultValue=""
          value={value}
          onChange={handleChange}
          setOptions={{
            showGutter: false,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            fontSize: 14,
            highlightActiveLine: true,
            tabSize: 4,
            useWorker: false,
          }}
        />
      </div>
    </>
  );
};

export default AceEditorField;
